import classNames from 'classnames';
import { Dispatch, SetStateAction } from 'react';
import { useSidebarShowSubItems } from '../../hooks/useSidebarShowSubItems';
import styleScroll from '../Sidebar.module.css';
import { MenuItem } from './MenuItem';
import { SidebarMenuItem } from './types';

interface MenuBlockProps {
  menuItems: SidebarMenuItem[];
  isOpened: boolean;
  setIsOpened?: Dispatch<SetStateAction<boolean>>;
  paddingY?: string;
  isSearchUsed?: boolean;
  search?: string;
}

export const MenuBlock = ({
  search,
  isOpened,
  menuItems,
  setIsOpened,
  isSearchUsed,
  paddingY = '8px',
}: MenuBlockProps) => {
  const { openItems, toggleOpenItem } = useSidebarShowSubItems();

  return (
    <div
      className={classNames(
        'w-full flex flex-col items-center justify-start',
        'gap-2 py-4 select-none overflow-y-auto relative',
        styleScroll.scroll,
      )}
    >
      {menuItems.map((item, i) => {
        const { label, subItems } = item;
        const id = `item_${i}`;
        const isOpenItem = openItems[id];

        return (
          <div className={classNames('w-full flex flex-col')} key={label + id}>
            <MenuItem
              item={item}
              search={search}
              isOpenItem={isOpenItem}
              toggleOpenItem={() => toggleOpenItem(id)}
              isOpened={isOpened}
              paddingY={paddingY}
              setIsOpened={setIsOpened}
              isSearchUsed={isSearchUsed}
            />
            {subItems && (
              <div
                className={classNames(
                  'w-auto flex flex-col items-center justify-start h-0 overflow-y-hidden',
                  'gap-2 border-l border-l-gray-700 ml-5 select-none overflow-y-auto relative',
                  'transition-all duration-500 ease-in-out',
                  {
                    'pt-2': isOpenItem, //!h-auto !h-[336px]
                  },
                  styleScroll.scroll,
                )}
                style={{ height: isOpenItem ? `${subItems?.length * 48}px` : undefined }}
              >
                {subItems.map((item, j) => {
                  const idSub = id + '_' + j;
                  const isOpenItem = openItems[idSub];
                  return (
                    <MenuItem
                      item={item}
                      key={idSub}
                      search={search}
                      isOpenItem={isOpenItem}
                      toggleOpenItem={() => toggleOpenItem(idSub)}
                      isOpened={isOpened}
                      paddingY={paddingY}
                      setIsOpened={setIsOpened}
                      isSearchUsed={isSearchUsed}
                    />
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
